<div class="quick-switch-popover"
     (mouseenter)="onMouseEnter()"
     (mouseleave)="onMouseLeave()">
  <div class="quick-switch-popover__surface">
    <!-- Search Box -->
    <div class="search-box">
      <mat-icon class="search-icon">search</mat-icon>
      <input type="text"
             class="search-input"
             placeholder="ユーザーを検索..."
             [value]="searchQuery()"
             (input)="onSearchInput($event)"
             aria-label="ユーザーを検索" />
    </div>

    <!-- User List -->
    <div class="user-list">
      @if (filteredUsers().length === 0) {
        <div class="empty-message">
          @if (searchQuery()) {
            <span>一致するユーザーが見つかりません</span>
          } @else {
            <span>最近のユーザーはいません</span>
          }
        </div>
      } @else {
        @for (user of filteredUsers(); track user.id) {
          <button class="user-item" (click)="selectUser(user)">
            <span class="user-avatar"
                  [class.avatar-male]="user.sex === 'male'"
                  [class.avatar-female]="user.sex === 'female'">
              {{ getInitials(user.name) }}
            </span>
            <span class="user-name">{{ user.name }}</span>
          </button>
        }
      }
    </div>
  </div>
</div>
